import script from "./ConfirmDialog.vue?vue&type=script&setup=true&name=ConfirmDialog&lang=js"
export * from "./ConfirmDialog.vue?vue&type=script&setup=true&name=ConfirmDialog&lang=js"

const __exports__ = script;

export default __exports__